import { render, staticRenderFns } from "./OrderDataTable.vue?vue&type=template&id=16318f26&scoped=true"
import script from "@/views/Users/OrderDataTable.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/OrderDataTable.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/order-data-table.scss?vue&type=style&index=0&id=16318f26&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16318f26",
  null
  
)

export default component.exports